module.exports = __WEBPACK_EXTERNAL_MODULE_1522__;


//////////////////
// WEBPACK FOOTER
// external "axios"
// module id = 1522
// module chunks = 0